import React from 'react'
import PropTypes from 'prop-types'

function ButtonWrap ({ children, className, center, leftAlign, grow, wrap, innerStyle = {} }) {
  const classNames = [
    'button-wrap',
    'flex',
    '-m-1',
    wrap ? 'flex-wrap' : '',
    center ? 'justify-center' : leftAlign ? '' : 'justify-end',
    grow ? 'button-wrap--grow' : ''
  ]

  return (
    <div className={className}>
      <div className={classNames.join(' ')} style={innerStyle}>
        {children}
      </div>
    </div>
  )
}

ButtonWrap.defaultProps = {
  className: 'my-4',
  grow: false,
  center: false,
  wrap: true
}

ButtonWrap.propTypes = {
  /**
     * Add a custom className to the grid's wrapper
     */
  className: PropTypes.string,
  /**
     * Should the buttons be centered in the container?
     * Default: false
     */
  center: PropTypes.bool,
  /**
     * Should the buttons be centered in the container?
     * Default: false
     */
  leftAlign: PropTypes.bool,
  /**
     * If set to true, flex-grow will be applied to the buttons
     * making them fill their container.
     * Default: false
     */
  grow: PropTypes.bool,
  /**
     * If set to true, the buttons will wrap to a new line,
     * when there's no empty space remaining
     * Default: true
     */
  wrap: PropTypes.bool
}

export default ButtonWrap
